import Checkbox from './Checkbox';

type ResourceCounterProps = {
    name?: string;
    total: number;
    spent: number;
    Icon?: React.ComponentType<{
        checked?: boolean;
        disabled?: boolean;
        size?: number | string;
        style?: React.CSSProperties;
    }>;
    size?: number | string;
    iconStyle?: React.CSSProperties;
    onChange: (
        spent: number,
    ) => void;
};


function ResourceCounter({
    name,
    total,
    spent,
    Icon,
    size = '1em',
    iconStyle = {},
    onChange
}: ResourceCounterProps) {
    return (
        <div
            style={{
                display: 'grid',
                gridTemplateColumns: '5em 1fr',
                alignItems: 'center',
                gap: '0.5em',
            }}
        >
            {name && (
                <span
                    style={{
                        fontWeight: 600,
                        whiteSpace: 'nowrap',
                        fontVariant: 'small-caps',
                    }}
                >
                    {name}
                </span>
            )}

            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    gap: '0.15em',
                }}
            >
                {Array.from(
                    { length: total },
                    (_, slotIndex) => (
                        <Checkbox
                            key={slotIndex}
                            Icon={Icon}
                            size={size}
                            iconStyle={iconStyle}
                            checked={slotIndex < spent}
                            onChange={(checked) => onChange(checked ? slotIndex + 1 : slotIndex)}
                        />
                    ),
                )}
            </div>
        </div>
    );
}

export default ResourceCounter;